import Select from '@components/v2/form/Select/Select';
import Switch from '@components/v2/form/Switch/Switch';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { GeneralSettingsParams } from '../../../../stores/GeneralSettings/generalSettings.types';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { MediaFormatEnum } from '../../enums/mediaFormat.enum';
import { MediaZoomTypeEnum } from '../../enums/mediaZoomType.enum';
import { getMediaFormatLangEnum } from '../../utils/getMediaFormatSelectLabel.utils';
import { getMediaZoomTypeLabelAndDescription } from '../../utils/getMediaZoomTypeSelectLabel.utils';
import { MediasSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const MediasSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: MediasSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  const mediaFormatItems = Object.keys(MediaFormatEnum).map((format) => ({
    value: format,
    label: translate(getMediaFormatLangEnum(format as MediaFormatEnum)),
  }));

  const mediaZoomItems = Object.keys(MediaZoomTypeEnum).map((format) => {
    const { label, description } = getMediaZoomTypeLabelAndDescription(format as MediaZoomTypeEnum);
    return {
      value: format,
      label: translate(label),
      description: translate(description),
    };
  });

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_MEDIAS)}
      description={LangEnum.GENERAL_SETTINGS_MEDIAS_INFO}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(LangEnum.BRAND_SETTINGS_MEDIA_SHOW_SIBLING_COLOR_MEDIA)}
          name="showSiblingColorMedia"
          size="medium"
          checked={generalSettings.showSiblingColorMedia}
          onChange={(event, checked) =>
            handleChangeAndBlur({
              value: checked,
              name: event.target.name as keyof GeneralSettingsParams,
            })
          }
        />
        <Select
          label={translate(LangEnum.GLOBAL_MEDIAS)}
          name="mediaFormat"
          value={generalSettings.mediaFormat ?? ''}
          renderValue={(selected) =>
            mediaFormatItems.find((item) => item.value === selected)?.label ?? ''
          }
          onChange={(event) =>
            handleChangeAndBlur({
              value: (event.target.value as string) || null,
              name: 'mediaFormat',
            })
          }
        >
          {mediaFormatItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        <Select
          label={translate(LangEnum.PRODUCT_MEDIA_ZOOM_TYPE)}
          name="mediaZoomType"
          value={generalSettings.mediaZoomType ?? ''}
          renderValue={(selected) =>
            mediaZoomItems.find((item) => item.value === selected)?.label ?? ''
          }
          onChange={(event) =>
            handleChangeAndBlur({
              value: (event.target.value as string) || null,
              name: 'mediaZoomType',
            })
          }
        >
          {mediaZoomItems.map((item) => (
            <MenuItem
              key={item.value}
              value={item.value}
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}
            >
              <Typography variant="body1">{item.label}</Typography>
              <Typography variant="body2" color="textSecondary">
                {item.description}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </SettingContainer>
  );
};

export default MediasSectionGeneralSettings;
